import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PaymentType, PaymentTypeUtil} from './payment-type';
import {TranslateService} from "@ngx-translate/core";
import {Language} from "../../models/language";
import {LANG} from "../../constants/local-storage.contant";
import {CookieUtils} from "../../utils/cookie.utils";

@Component({
  selector: 'app-payment-type',
  templateUrl: './payment-type.component.html',
  styleUrls: ['./payment-type.component.scss', '../../shipping-method/delivery-select/delivery-select.component.scss']
})
export class PaymentTypeComponent implements OnInit {
  @Input() paymentType: PaymentType = PaymentType.CREDIT_CARD;
  @Input() isSelected: boolean = false;

  @Input() isPaymentTypeSelect: boolean = true;
  @Input() label: string = 'label';
  @Input() name: string = 'radioButton';
  @Input() useDifferentBillingAddress: boolean = false;
  @Input() cardLastDigits: string | null = null;
  @Input() disabled: boolean = false;
  @Input() translation: boolean = false;

  @Output() selectType: EventEmitter<PaymentType> = new EventEmitter<PaymentType>();

  public isSelectedTypeCreditCard: boolean = false;

  constructor(
    private translateService: TranslateService
  ) {
    this.translateService.use(CookieUtils.getCookie(LANG) || Language.HY);
  }

  ngOnInit() {
    this.isSelectedTypeCreditCard = this.paymentType == PaymentType.CREDIT_CARD || this.paymentType == PaymentType.EXISTING_CREDIT_CARD;
  }

  get titleByPaymentType() {
    if (!this.isSelectedTypeCreditCard) {
      return this.paymentType;
    }

    if (this.cardLastDigits) {
      const cardLastDigitsLength = this.cardLastDigits.length;
      const fourStartsAndLastDigits = this.cardLastDigits.slice(cardLastDigitsLength - 9, cardLastDigitsLength);
      return `${PaymentType.CREDIT_CARD} (${fourStartsAndLastDigits})`;
    }

    const payWithNew = this.translateService.instant('payment.payWithNew');
    return `${payWithNew} ${this.paymentType}`;
  }

  protected select(): void {
    if(this.disabled) return;
    this.selectType.emit(this.paymentType);
  }

  protected readonly PaymentTypeUtil = PaymentTypeUtil;
  protected readonly PaymentType = PaymentType;
}
